// extracted by mini-css-extract-plugin
export default {"bodyContainer":"Privacy_bodyContainer__rin6k","privacyContainer":"Privacy_privacyContainer__AUKFS","subtitle":"Privacy_subtitle__XFtpg"};